const fontWeight = {
  primary: {
    heavy: { value: '700' },
    semi: { value: '600' },
    medium: { value: '500' },
    reg: { value: '400' },
    light: { value: '300' },
  },
  secondary: {
    reg: { value: '400' },
  },
};

const size = {
  xs: {
    '01': { value: '0.125' },
    '02': { value: '0.25' },
    '03': { value: '0.375' },
    '04': { value: '0.425' },
  },
  sm: {
    '01': { value: '0.5' },
    '02': { value: '0.625' },
    '03': { value: '0.75' },
    '04': { value: '14' },
  },
  md: {
    '01': { value: '1' },
    '02': { value: '18' },
    '03': { value: '20' },
    '04': { value: '22' },
  },
  lg: {
    '01': { value: '24' },
    '02': { value: '28' },
    '03': { value: '2' },
    '04': { value: '36' },
  },
  xl: {
    '01': { value: '2.50' },
    '02': { value: '3' },
    '03': { value: '3.375' },
    '04': { value: '3.75' },
  },
  xxl: {
    '01': { value: '4.25' },
    '02': { value: '4.75' },
    '03': { value: '5.25' },
    '04': { value: '6' },
  },
};
const fontFamily = {
  primaryNew: { value: 'Basis Grt' },
  secondaryNew: { value: 'Burgess' },
  primary: { value: 'Inter' },
  secondary: { value: 'Libre Baskerville' },
};
export const fontFamilyFallback = {
  primary: 'sans-serif',
  secondary: 'serif',
};
export const primaryFont = `${fontFamily['primary'].value}, ${fontFamilyFallback.primary}`;
export const secondaryFont = `${fontFamily['secondary'].value}, ${fontFamilyFallback.secondary}`;
export const primaryFontNew = `${fontFamily['primaryNew'].value}, ${fontFamilyFallback.primary}`;
export const secondaryFontNew = `${fontFamily['secondaryNew'].value}, ${fontFamilyFallback.secondary}`;
export interface MidwestTypographyToken {
  font: string;
  rem: string;
  weight: string;
  lineHeight: string | number;
  textTransform?: string;
  letterSpacing?: string;
  textDecoration?: string;
  textDecorationStyle?: string;
  textDecorationThickness?: string;
  textUnderlineOffset?: string;
}
export const textBodyHeavyDefault: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['md']['01'].value,
  lineHeight: 22,
};
export const textBodyHeavySm: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['sm']['04'].value,
  lineHeight: 20,
};
export const textBodyHeavyXs: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['sm']['03'].value,
  lineHeight: 18,
};
export const textBodyMediumDefault: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['md']['01'].value,
  lineHeight: 22,
};
export const textBodyMediumSm: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['sm']['04'].value,
  lineHeight: 20,
};
export const textBodyMediumXs: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['sm']['03'].value,
  lineHeight: 18,
};
export const textBodyRegDefault: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['reg'].value,
  rem: size['md']['01'].value,
  lineHeight: 22,
};
export const textBodyRegSm: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['reg'].value,
  rem: size['sm']['04'].value,
  lineHeight: 20,
};
export const textBodyRegXs: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['reg'].value,
  rem: size['sm']['03'].value,
  lineHeight: 18,
};
export const textMiniDefault: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['reg'].value,
  rem: size['sm']['02'].value,
  lineHeight: 14,
};
export const textMiniDefaultLink: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['reg'].value,
  rem: size['sm']['02'].value,
  lineHeight: 14,
};
export const textRegDefaultLink: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['reg'].value,
  rem: size['md']['01'].value,
  lineHeight: 22,
};
export const textRegSmLink: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['reg'].value,
  rem: size['sm']['04'].value,
  lineHeight: 20,
};
export const textRegXsLink: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['reg'].value,
  rem: size['sm']['03'].value,
  lineHeight: 18,
};
export const textHeroDesktopXl: MidwestTypographyToken = {
  font: secondaryFont,
  weight: fontWeight['secondary']['reg'].value,
  rem: size['xl']['03'].value,
  lineHeight: 72,
};
export const textHeroDesktopLg: MidwestTypographyToken = {
  font: secondaryFont,
  weight: fontWeight['secondary']['reg'].value,
  rem: size['xl']['01'].value,
  lineHeight: 52,
};
export const textHeroDesktopMd: MidwestTypographyToken = {
  font: secondaryFont,
  weight: fontWeight['secondary']['reg'].value,
  rem: size['lg']['03'].value,
  lineHeight: 44,
};
export const textHeroDesktopSm: MidwestTypographyToken = {
  font: secondaryFont,
  weight: fontWeight['secondary']['reg'].value,
  rem: size['lg']['01'].value,
  lineHeight: 32,
};
export const textHeroMobileXl: MidwestTypographyToken = {
  font: secondaryFont,
  weight: fontWeight['secondary']['reg'].value,
  rem: size['xl']['01'].value,
  lineHeight: 56,
};
export const textHeroMobileLg: MidwestTypographyToken = {
  font: secondaryFont,
  weight: fontWeight['secondary']['reg'].value,
  rem: size['lg']['04'].value,
  lineHeight: 48,
};
export const textHeroMobileMd: MidwestTypographyToken = {
  font: secondaryFont,
  weight: fontWeight['secondary']['reg'].value,
  rem: size['lg']['02'].value,
  lineHeight: 36,
};
export const textHeroMobileSm: MidwestTypographyToken = {
  font: secondaryFont,
  weight: fontWeight['secondary']['reg'].value,
  rem: size['md']['03'].value,
  lineHeight: 28,
};
export const textTitleDesktopXl: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['xl']['01'].value,
  lineHeight: 52,
};
export const textTitleDesktopLg: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['lg']['03'].value,
  lineHeight: 42,
};
export const textTitleDesktopMd: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['lg']['01'].value,
  lineHeight: 32,
};
export const textTitleDesktopSm: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['md']['03'].value,
  lineHeight: 28,
};
export const textTitleMobileXl: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['lg']['04'].value,
  lineHeight: 46,
};
export const textTitleMobileLg: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['lg']['02'].value,
  lineHeight: 36,
};
export const textTitleMobileMd: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['md']['04'].value,
  lineHeight: 28,
};
export const textTitleMobileSm: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['md']['02'].value,
  lineHeight: 24,
};
export const textSubTitleDesktopMd: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['md']['03'].value,
  lineHeight: 28,
};
export const textSubTitleMobileMd: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['md']['02'].value,
  lineHeight: 26,
};
export const textDataDesktopLg: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['xl']['02'].value,
  lineHeight: 64,
};
export const textDataDesktopMd: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['lg']['04'].value,
  lineHeight: 46,
};
export const textDataDesktopSm: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['lg']['01'].value,
  lineHeight: 32,
};
export const textDataMobileLg: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['lg']['04'].value,
  lineHeight: 46,
};
export const textDataMobileMd: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['lg']['02'].value,
  lineHeight: 36,
};
export const textDataMobileSm: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['md']['04'].value,
  lineHeight: 28,
};
export const textInterfaceHeavyDefault: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['md']['01'].value,
  lineHeight: 20,
};
export const textInterfaceHeavySmall: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['sm']['04'].value,
  lineHeight: 16,
};
export const textInterfaceHeavyXs: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['heavy'].value,
  rem: size['sm']['03'].value,
  lineHeight: 16,
};
export const textInterfaceSemiDefault: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['semi'].value,
  rem: size['md']['01'].value,
  lineHeight: 16,
};
export const textInterfaceSemiSm: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['semi'].value,
  rem: size['sm']['04'].value,
  lineHeight: 16,
};
export const textInterfaceSemiXs: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['semi'].value,
  rem: size['sm']['03'].value,
  lineHeight: 16,
};
export const textInterfaceMediumDefault: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['md']['01'].value,
  lineHeight: 16,
};
export const textInterfaceMediumSmall: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['sm']['04'].value,
  lineHeight: 16,
};
export const textInterfaceMediumXs: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['sm']['03'].value,
  lineHeight: 16,
};
export const textInterfaceRegularDefault: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['reg'].value,
  rem: size['md']['01'].value,
  lineHeight: 16,
};
export const textInterfaceRegularSm: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['reg'].value,
  rem: size['sm']['04'].value,
  lineHeight: 16,
};
export const textInterfaceRegularXs: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['reg'].value,
  rem: size['sm']['03'].value,
  lineHeight: 16,
};
export const componentTableTextHeading: MidwestTypographyToken = {
  font: primaryFont,
  weight: fontWeight['primary']['medium'].value,
  rem: size['sm']['03'].value,
  lineHeight: 16,
  textTransform: 'capitalize',
};

export const componentTableTextHeadingNew: MidwestTypographyToken = {
  font: 'primary',
  weight: 'medium',
  rem: '1',
  lineHeight: 'xxxxs',
  textTransform: 'capitalize',
};
//New Typo Tokens
export const headingBlack1000: MidwestTypographyToken = {
  font: 'primary',
  weight: 'heavy',
  rem: '13',
  lineHeight: 'xxxxxxxl',
};
export const headingBlack800: MidwestTypographyToken = {
  font: 'primary',
  weight: 'heavy',
  rem: '11',
  lineHeight: 'xxxxl',
};

export const headingBold1000: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '13',
  lineHeight: 'xxxxxxl',
};

export const headingBold800: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '11',
  lineHeight: 'xxxxl',
};

export const headingBold600: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '8',
  lineHeight: 'xxl',
};

export const headingBold500: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '7',
  lineHeight: 'xl',
};

export const headingBold400: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '6',
  lineHeight: 'l',
};

export const headingLight1000: MidwestTypographyToken = {
  font: 'primary',
  weight: 'light',
  rem: '13',
  lineHeight: 'xxxxxxl',
};
export const headingLight800: MidwestTypographyToken = {
  font: 'primary',
  weight: 'light',
  rem: '11',
  lineHeight: 'xxxxl',
};
export const headingLight600: MidwestTypographyToken = {
  font: 'primary',
  weight: 'light',
  rem: '8',
  lineHeight: 'xxl',
};
export const headingExpressive1000: MidwestTypographyToken = {
  font: 'secondary',
  weight: 'heavy',
  rem: '13',
  lineHeight: 'xxxxxxxl',
};
export const headingExpressive800: MidwestTypographyToken = {
  font: 'secondary',
  weight: 'heavy',
  rem: '11',
  lineHeight: 'xxxxl',
};
export const headingExpressive600: MidwestTypographyToken = {
  font: 'secondary',
  weight: 'heavy',
  rem: '9',
  lineHeight: 'xxl',
};

export const bodyBold300: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '4',
  lineHeight: 'l',
};

export const bodyBold200: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '3',
  lineHeight: 'm',
};
export const bodyBold150: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '2',
  lineHeight: 's',
};
export const bodyBold100: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '1',
  lineHeight: 'xs',
};
export const bodyBold50: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: 'mini',
  lineHeight: 'xxxs',
};

export const bodyRegular300: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '4',
  lineHeight: 'l',
};

export const bodyRegular200: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '3',
  lineHeight: 'l',
};
export const bodyRegular150: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '2',
  lineHeight: 's',
};
export const bodyRegular100: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '1',
  lineHeight: 'xxs',
};
export const bodyRegular50: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: 'mini',
  lineHeight: 'xxxs',
};

export const linkBold300: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '4',
  lineHeight: 'l',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationThickness: '2px',
  textUnderlineOffset: '2px',
};

export const linkBold200: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '3',
  lineHeight: 'm',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationThickness: '2px',
  textUnderlineOffset: '2px',
};
export const linkBold150: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '2',
  lineHeight: 's',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationThickness: '2px',
  textUnderlineOffset: '2px',
};
export const linkBold100: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '1',
  lineHeight: 'xs',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationThickness: '2px',
  textUnderlineOffset: '2px',
};
export const linkBold50: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: 'mini',
  lineHeight: 'xxxs',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationThickness: '2px',
  textUnderlineOffset: '2px',
};
export const linkRegular300: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '4',
  lineHeight: 'l',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationThickness: '1px',
  textUnderlineOffset: '2px',
};
export const linkRegular200: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '3',
  lineHeight: 'm',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationThickness: '1px',
  textUnderlineOffset: '2px',
};
export const linkRegular150: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '2',
  lineHeight: 's',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationThickness: '1px',
  textUnderlineOffset: '2px',
};
export const linkRegular100: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '1',
  lineHeight: 'xs',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationThickness: '1px',
  textUnderlineOffset: 'auto',
};
export const linkRegular50: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: 'mini',
  lineHeight: 'xxxs',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationThickness: '1px',
  textUnderlineOffset: 'auto',
};
export const eyebrow250: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '4',
  lineHeight: 'xs',
  letterSpacing: '2px',
  textTransform: 'uppercase',
};
export const eyebrow150: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '2',
  lineHeight: 'xxxs',
  letterSpacing: '1px',
  textTransform: 'uppercase',
};
export const eyebrow50: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: 'mini',
  lineHeight: 'xxxxs',
  letterSpacing: '1px',
  textTransform: 'uppercase',
};

export const numericRegular600: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '8',
  lineHeight: 'xxl',
};

export const numericRegular500: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '7',
  lineHeight: 'xl',
};

export const numericRegular400: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '6',
  lineHeight: 'l',
};

export const numericRegular300: MidwestTypographyToken = {
  font: 'primary',
  weight: 'reg',
  rem: '4',
  lineHeight: 's',
};

export const labelBold200: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '3',
  lineHeight: 'xs',
};
export const labelBold150: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '2',
  lineHeight: 'xs',
};
export const labelBold100: MidwestTypographyToken = {
  font: 'primary',
  weight: 'semi',
  rem: '1',
  lineHeight: 'xxxs',
};
export const labelMedium200: MidwestTypographyToken = {
  font: 'primary',
  weight: 'medium',
  rem: '3',
  lineHeight: 'xs',
};
export const labelMedium150: MidwestTypographyToken = {
  font: 'primary',
  weight: 'medium',
  rem: '2',
  lineHeight: 'xxs',
};
export const labelMedium100: MidwestTypographyToken = {
  font: 'primary',
  weight: 'medium',
  rem: '1',
  lineHeight: 'xxxs',
};
